import {
  Home,
  Map,
  Clapperboard,
  Tv,
  LayoutGrid,
  Sparkles,
  Heart,
  Radio,
} from "lucide-react";

// Navegación principal (el Área VIP vive como CTA destacado, no se repite aquí)
export const NAV = [
  { to: "/", label: "Home", icon: Home },
  { to: "/la-ruta", label: "La Ruta", icon: Map },
  { to: "/el-formato", label: "El Formato", icon: Clapperboard },
  { to: "/episodios", label: "Episodios", icon: Tv },
  { to: "/la-app", label: "La App", icon: LayoutGrid },
  { to: "/anto-bella", label: "Anto&Bella", icon: Sparkles },
  { to: "/believers", label: "Believers", icon: Heart },
  { to: "/en-vivo", label: "En Vivo", icon: Radio },
];

export const NAV_B2B = [
  { to: "/patrocinadores", label: "Para Patrocinadores" },
  { to: "/marcas", label: "Para Marcas" },
];
